import {getBackendInformation} from 'utility/Provide/BackendInformation';

interface UrlDataInterface {
    controldUrl: string;
    adminUrl: string;
}

const getUrlData = (type: keyof UrlDataInterface): string => {
    return getBackendInformation<UrlDataInterface>()[type];
};

export function getDebuggingWonderlandUrl(transactionId: string) {
    return (
        `//${getUrlData('controldUrl')}/hotelSearch/request/index?transactionID=${transactionId}`
    );
}

export function getTransactionAdminUrl(transactionId: string) {
    return (
        `//${getUrlData('adminUrl')}/transactions?transactionId=${transactionId}&search=Anzeigen`
    );
}
